define('SageDotCom/Components/MultiStepPanel/MultiStepPanelContainer',['jquery',
    "underscore",
    "eventManager",
    "SageDotCom/Components/ProductCardAlignment",
    "text!SageDotCom/Components/Templates/MultiStepPanelHeading.html"],
    function ($, _, eventManager, ProductCardAlignment, headingTemplate) {

        function MultiStepPanelContainer(scope) {
            const $scope = $(scope);
            const panels = $scope.find(".multi-step-panel-panel");
            const headingsContainer = $scope.find(".multi-step-panel-steps-headings");
            const totalPanels = $(panels).length;

            let currentStep = 0;
            const moveToNextStep = function (productName, buttonText, nonBundleUrl) {
                if (currentStep >= panels.length - 1) {
                    //Current step is last step
                }
                else {
                    const headings = headingsContainer.find(".multi-step-panel-heading");
                    const currentHeading = headings.eq(currentStep);
                    const currentPanel = panels.eq(currentStep);
                    const currentHeadingLink = $(currentHeading).find(".multi-step-panel-heading-inner-link-text");
                    currentHeadingLink.text(buttonText);

                    const nextHeading = headings.eq(currentStep + 1);
                    const nextPanel = panels.eq(currentStep + 1);

                    var comparisonTableSlicked = $(nextPanel).find(".product-comparison-table-full-component .product-cards-container.slick-initialized");

                    if (comparisonTableSlicked != null && comparisonTableSlicked.length > 0) {
                        const loader = document.querySelector(".sage-loader");
                        if (loader) {
                            loader.classList.add("show");
                            setTimeout(function () {
                                loader.classList.add("fadeIn");
                            }, 10)
                        }
                    }

                    currentPanel.removeClass("open");
                    nextPanel.addClass("open");

                    ProductCardAlignment.refreshProductCardHeights();

                    currentHeading.removeClass("active").addClass("done").attr("tabindex", 0);
                    nextHeading.addClass("active");

                    //set buy url on the appropriate buttons on the product cards in this next step
                    const btns = nextPanel.find(".dynamic-product-card-non-bundle-buy-btn");
                    //extract sku from the href
                    const sku = getSkuFromUrl(nonBundleUrl);
                    eventManager.trigger("multi-step-panel-change", nextPanel.attr("id"), sku, productName);

                    btns.each(function (i, btn) {
                        $(btn).attr("href", encodeURI(nonBundleUrl));
                        $(btn).show();
                    });

                    currentStep = currentStep + 1;

                    // trigger this event as a fallback in case dynamic price box/bundled price box has not been populated yet so header is not empty
                    eventManager.trigger("populate-comparison-header", productName);
                    eventManager.trigger("slick-cards-refresh");
                    eventManager.trigger("slick-comparison-table-refresh");
                    $('html, body').animate({
                        scrollTop: ($(".multi-step-panel-container").offset().top)
                    }, 500);

                    setTimeout(function () {
                        $(".sage-loader").removeClass("show");
                    }, 2000);
                }
            }

            const getSkuFromUrl = function (url) {
                const skuIndex = url.indexOf("sku=");
                if (skuIndex > -1) {
                    url = url.substring(skuIndex + 4);

                    const andIndex = url.indexOf("&");
                    if (andIndex > -1) {
                        url = url.substring(0, andIndex);
                    }
                }

                return url;
            }

            $(headingsContainer).on("click", ".multi-step-panel-heading.done", function () {
                const headingIndex = $(this).data("index");

                if (headingIndex >= 0 && headingIndex < totalPanels) {
                    const headings = headingsContainer.find(".multi-step-panel-heading");
                    //disable all panels and headings
                    headings.removeClass("active");
                    panels.removeClass("open");

                    var comparisonTableSlicked = $(panels.eq(headingIndex)).find(".product-comparison-table-full-component .product-cards-container.slick-initialized");

                    if (comparisonTableSlicked != null && comparisonTableSlicked.length > 0) {
                        const loader = document.querySelector(".sage-loader");
                        if (loader) {
                            loader.classList.add("show");
                            setTimeout(function() {
                                    loader.classList.add("fadeIn");
                                },
                                10);
                        }
                    }

                    //set specified heading and panel as active
                    headings.eq(headingIndex).addClass("active").removeClass("done").attr("tabindex", "");
                    panels.eq(headingIndex).addClass("open");

                    //Run match height on all of the cards in the displayed panel
                    ProductCardAlignment.refreshProductCardHeights();

                    //remove done from all headings after this one
                    headingsContainer.find(".multi-step-panel-heading:gt(" + headingIndex + ")").attr("tabindex", "").removeClass("done");

                    currentStep = headingIndex;

                    eventManager.trigger("populate-comparison-header");
                    eventManager.trigger("slick-cards-refresh");
                    eventManager.trigger("slick-comparison-table-refresh");

                    setTimeout(function () {
                        $(".sage-loader").removeClass("show");
                    }, 2000);
                }
            });

            $(headingsContainer).on("keyup", ".multi-step-panel-heading.done", function (event) {
                if (event.keyCode === 13) {
                    $(this).click();
                }
            });

            let headingHtml = "";
            panels.each(function (i, panel) {
                const panelData = {
                    index: i,
                    title: $(panel).data("panel-title"),
                    subtitle: $(panel).data("panel-subtitle")
                };

                let _headingTemplate = _.template(headingTemplate);
                headingHtml += _headingTemplate(panelData);

                if (i === 0) {
                    $(panel).addClass("open");
                }

                //Get each button in the product cards in the panel
                if (i < totalPanels - 1) {
                    const buttons = $(panel).find(".sage-product-card-outer .multi-step-panel-next-step-btn");
                    $(buttons).each(function (bi, button) {
                        const href = $(button).attr("href");
                        $(button).removeAttr("href");
                        $(button).attr("role", "button");
                        $(button).attr("data-href", href);
                        $(button).on("click", function () {
                            //need product name and price
                            const parentCard = $(button).parents(".sage-product-card-outer");
                            const productName = parentCard.find(".sage-product-card-title").text();
                            const productPrice = parentCard.find(".sage-product-card-price-box .price").text();

                            const stepText = productName + " (" + productPrice + "/mo)";
                            moveToNextStep(productName, stepText, href);
                        });
                    });
                }
            });

            $(headingsContainer).html(headingHtml);

            eventManager.subscribe("multistep-reattach-next-step-events", function () {
                // remove old event listeners and reattach so that the events still fire when in slick slider
                const buttons = $(scope).find(".sage-product-card-outer .multi-step-panel-next-step-btn");
                $(buttons).each(function (bi, button) {
                    const href = $(button).attr("data-href");
                    $(button).off("click").on("click", function () {
                        //need product name and price
                        const parentCard = $(button).parents(".sage-product-card-outer");
                        const productName = parentCard.find(".sage-product-card-title").text();
                        const productPrice = parentCard.find(".sage-product-card-price-box .price").text();

                        const stepText = productName + " (" + productPrice + "/mo)";
                        moveToNextStep(productName, stepText, href);
                    });

                    $(button).off("keyup").on("keyup", function (event) {
                        if (event.keyCode === 13) {
                            $(this).click();
                        }
                    });
                });
            });
        }

        return function init(args) {
            return args.IsExperienceEditorEditing ? null : new MultiStepPanelContainer(args.scope);
        }
    });
